import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "Do I need drawing or artistic skills to learn UI/UX?",
    
    description:
      "No. UI/UX is more about problem-solving, understanding users, and designing intuitive layouts. Creativity helps, but you don’t need advanced drawing skills — most work is done using digital tools.",
  },
  {
    title: "What tools are used in UI/UX designing?",

    description:
      "Popular tools include Figma, Adobe XD, Sketch, Illustrator, Photoshop, Miro, and Zeplin. Most designers primarily work in Figma because it’s easy to learn, collaborative, and widely used in the industry.",
  },
  {
    title: "What industries hire UI/UX designers?",
   
    description:
      "Almost every industry needs UI/UX designers — IT, e-commerce, fintech, healthcare, education, real estate, travel, SaaS, and startups. Any business with a website or app relies on good design.",
  },
  {
    title: "Do UI/UX designers work with developers?",
  
    description:
      "Learn wireframing, user psychology, color system, typography & real prototype workflow.",
  },
  {
    title: "What is the difference between UI and UX?",
    
    description:
      "UI (User Interface) focuses on visuals like colors, icons, buttons, and layouts. UX (User Experience) focuses on user flow, navigation, research, usability, and how smoothly a user interacts with the product.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                <div className="category">{item.category}</div>

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
